import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import PlantillaScreen from '../../helpers/PlantillaScreen';
import { GetText } from '../../../Helpers/GetKey';
import { LoaderScreen } from '../../components/LoaderScreen';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from "react-router-dom";
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import ModalVisualizacionPDF from "./Modales/ModalVisualizacionPDF";


export const ReferenciaBancariaMainScreen = () => {
    const history = useHistory();

    const [clienteslist, setClienteList] = useState([]);
    const [clienteselect, setClienteSelect] = useState("");
    const [cliente, setCliente] = useState("")

    const [mostrarModal, setMostrarModal] = useState(false);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        request
            .get("ReferenciaBancaria/Listado")
            .then((result) => {
                setClienteList(result);
            })
            .catch((error) => {
                Swal.fire("REFERENCIAS BANCARIAS", JSON.stringify(error), "error");
            });
    }, []);


    const onRegresar = () => {
        history.push("/Ventas/Main");

    }
    return (
        <PlantillaScreen
            titulo={`REFERENCIA BANCARIA ${clienteselect !== "" && clienteselect !== undefined && clienteselect !== null ? "-" + GetText(clienteselect) : ""}`}
            className_main={1}
            className={"reestructuracion-credito-main-screen"}
        >
            <LoaderScreen loader={loader} />

            <div className="reestructurar-credito-boton-regresar-container">
                <button
                    className="reestructurar-credito-boton-regresar "
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon />
                    REGRESAR
                </button>
            </div>
            <div style={{ marginBottom: 10, marginTop: 30, marginLeft: 20, marginRight: 20 }}>
                <Autocomplete
                    size="small"
                    id="dash-razonsocial"
                    freeSolo
                    className="reestructurar-credito-buscar-cliente-autocomplete"
                    value={clienteselect}
                    onChange={(event, value) => {
                        setClienteSelect(value);          // value es "123 - Razón Social"
                        setCliente(value?.split(" - ")[0] || ""); // extrae idcliente
                    }}
                    options={clienteslist.map(option => `${option.idcliente} - ${option.razonsocial}`)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="SELECCIONAR CLIENTE"
                        />
                    )}
                />
            </div>
            {clienteselect !== "" && clienteselect !== undefined && clienteselect !== null && (
                <div className="reestructurar-credito-solicitud-container">
                    <ModalVisualizacionPDF
                        onClose={() => setMostrarModal(false)}
                        open={mostrarModal}
                        idcliente={cliente}
                    />
                </div>
            )
            }
        </PlantillaScreen >
    )
}
